module.exports = __webpack_public_path__ + "static/img/4389.efb53b0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/4389.svg
// module id = 1lCA
// module chunks = 1